<template>
    <div ref="editorContainer" class="" id="editorContainer"></div>

</template>

<script setup>
import { ref, onMounted, reactive } from 'vue';
import { Icon } from "@iconify/vue/dist/offline";
import ToolTip from "./Tooltip.vue";
import Tooltip from './Tooltip.vue';
import { uuid } from '@vueform/vueform';


const props = defineProps(['codeContent']);

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
    .replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0, 
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}
const headers = ref([]);

function ResetHeaders(){
  headers.value = ref([]);
  addNewHeader();
}

function addNewHeader() {
  console.log(headers.length);
  headers.value.push({
    id:uuidv4(),
    name: "",
    value: ""
  });
}

function removeHeader(id) {
  console.log(id);
 headers.value=headers.value.filter(x => x.id !== id);
}


const knownVars = ref(["transcriptionArray", "summary","overallSentimentAnalysisObject","userSentimentAnalysisObject",
  "agentSentimentAnalysisObject","topicsArray","tagsArray", "detectedGenderObject", "isConversationFollowUp",
  "conversationType","crs","nps","cursesDetected","cursesFoundArray","profilesFoundArray","actionArray","messagesArray","conversationSubject"
]);
const actionName = ref("");
const httpType = ref("GET");
const url = ref("");
const bodyContent = ref(props.codeContent !== undefined && props.codeContent !== null && props.codeContent !== '' ? props.codeContent : `{
  "field":"value"
}`);
const editorContainer = ref(null);
let codeMirrorInstance = null;



function saveAction() {
  console.log("Action Saved:", {
    name: actionName.value,
    httpType: httpType.value,
    url: url.value,
    body: bodyContent.value
  });

  alert("Action saved! Check console for details.");
}

function applyVariableDecorations(content) {
  const doc = codeMirrorInstance.getDoc();
  const marks = doc.getAllMarks();
  marks.forEach(mark => mark.clear());
  const matches = [...content.matchAll(/\{\{\s*([^}]+)\s*\}\}/g)];
  matches.forEach(match => {
    const varName = match[1].trim();
    const startPos = match.index;
    const endPos = startPos + match[0].length;
    if (startPos === undefined) return;
    const start = posToCodeMirrorPos(content, startPos);
    const end = posToCodeMirrorPos(content, endPos);
    const isKnown = knownVars.value.includes(varName);
    doc.markText(start, end, { className: isKnown ? "cm-variable-known" : "cm-variable-unknown" });
  });
}

function posToCodeMirrorPos(str, index) {
  const lines = str.substring(0, index).split("\n");
  const line = lines.length - 1;
  const ch = lines[lines.length - 1].length;
  return { line, ch };
}

onMounted(() => {
  headers.value = [{
  id:uuidv4(),
  name:"",
  value:""
}];

let data = props.codeContent;

  codeMirrorInstance = CodeMirror(editorContainer.value, {
    value: bodyContent.value,
    mode: "application/json",
    lineNumbers: false,
    styleActiveLine: true,
    theme: "clouds",
    matchBrackets: true,
    autoCloseBrackets: true,
    extraKeys: {
      "Ctrl-Space": "autocomplete"
    },
    hintOptions: {
      completeSingle: false,
      hint: (cm) => {
        const cur = cm.getCursor();
        const token = cm.getTokenAt(cur);
        const word = token.string;
        const start = token.start;
        const end = token.end;
        const suggestions = knownVars.value.filter(v => v.toLowerCase().startsWith(word.toLowerCase()));
        return {
          list: suggestions.length > 0 ? suggestions : knownVars.value,
          from: CodeMirror.Pos(cur.line, start),
          to: CodeMirror.Pos(cur.line, end)
        };
      }
    }
  });
  codeMirrorInstance.on("change", () => {
    bodyContent.value = codeMirrorInstance.getValue();
    applyVariableDecorations(bodyContent.value);
  });
  applyVariableDecorations(bodyContent.value);

 
  

  loadStyle(`

  
#editorContainer {
    height: 41vh !important;
    border-radius: 10px !important;

      border: 1px solid #ccc;
      background-color: #f9fafb;
    }

    .CodeMirror{
    height:100% !important;
    border-radius:10px;
}

    .spin-me {
      animation: spin 1s linear infinite;
      transform-origin: center;
    }
      .CodeMirror-gutter-elt{
          display: none;
      }
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    .cm-variable-known {
      background-color: #c6f6d5 !important;
      color: #4a5568 !important;
    }
    .cm-variable-unknown {
      background-color: #fed7d7 !important;
      color: #4a5568 !important;
    }
      .cm-s-clouds{
        font-size:12px !important;
      }
  `);


});
function loadStyle(cssString) {

  const style = document.createElement('style');


  style.type = 'text/css';


  if (style.styleSheet !== undefined && style.styleSheet !== null) {
    style.styleSheet.cssText = cssString;
  } else {

    style.appendChild(document.createTextNode(cssString));
  }


  document.head.appendChild(style);
}




</script>
